<template>
  <SheetModal
    class="EditRunModalView"
    data-theme="light"
    aria-label="Edit the run"
    :aria-busy="isRequesting || isSaving"
    @close="$emit('close')"
  >
    <RunFormView
      v-bind="{ runId }"
      v-model:isRequesting="isRequesting"
      title="Edit the run"
      @cancel="$emit('close')"
      @submit="handleSubmit"
    />
  </SheetModal>
</template>

<script lang="ts" setup>
import SheetModal from "@/components/SheetModal.vue";
import { supabaseClient } from "@/lib/database/supabase";
import useModalStore from "@/stores/useModalStore";
import useRunCarouselStore from "@/stores/useRunCarouselStore";
import useRunStore from "@/stores/useRunStore";
import useSeasonStore from "@/stores/useSeasonStore";
import RunFormView from "@/views/commish/RunFormView.vue";
import { InsertRunWithCrewsArgs, UpdateRunWithCrewsArgs } from "@shared/lib/database/function.types";
import { ref } from "vue";

defineEmits<{
  close: [],
}>();

const {
  runId,
} = defineProps<{
  runId: string,
}>();

const {
  closeActiveModal,
} = useModalStore();

const {
  fetchRun,
} = useRunStore();

const {
  fetchRun: fetchRunForCarousel,
} = useRunCarouselStore();

const {
  fetchHomeSeasons,
} = useSeasonStore();

const isRequesting = ref(true);
const isSaving = ref(false);

async function handleSubmit (payload: InsertRunWithCrewsArgs | UpdateRunWithCrewsArgs | undefined) {
  if (!payload) return;

  isSaving.value = true;

  const {
    data: _run,
    error,
  } = await supabaseClient.rpc("update_run_with_crews", {
    court_id: payload.court_id,
    crew_ids: payload.crew_ids,
    start_at: payload.start_at,
    end_at: payload.end_at,
    min_player_count: payload.min_player_count,
    max_player_count: payload.max_player_count,
    rsvp_day_count: payload.rsvp_day_count,
    run_id: runId,
  });

  if (error) {
    alert(error.message);
  } else {
    // TODO: shouldn’t need to fetch these here
    // if there’s a better way to update the rest of the app
    // Also, DRY between here and ScheduleRunModalView
    fetchRun(runId);
    fetchRunForCarousel(runId);
    if (_run.season_id) fetchHomeSeasons();

    closeActiveModal();
  }

  isSaving.value = false;
}
</script>
